import { useEffect, useState } from 'react';

import FulfilmentProviderOrigin from '@/shared/types/fulfilment/fulfilmentProviderOrigin.type';
import Order from '@/shared/types/order/order.type';
import ShippingProfile from '@/shared/types/shipping/shippingProfile.type';

type Args = {
  order: Order;
  shippingProfiles: ShippingProfile[] | null;
  fulfilmentProviderOrigins: FulfilmentProviderOrigin[] | null;
};

const useSetOriginForm = ({
  order,
  shippingProfiles,
  fulfilmentProviderOrigins,
}: Args) => {
  const [pickOriginForm, setPickOriginForm] = useState({
    fulfilmentOrigin: '',
    useCustomsBroker: false,
    use_carrier: true,
    source: 'details',
    package_type: '',
    name: '',
    account_number: '',
    phone_number: '',
    email_address: '',
    fax_number: '',
    usmc_number: '',
    fda_number: '',
  });

  useEffect(() => {
    if (shippingProfiles) {
      setPickOriginForm((prev) => ({
        ...prev,
        package_type: shippingProfiles[0].package_type,
      }));
    }
  }, [shippingProfiles]);

  useEffect(() => {
    if (fulfilmentProviderOrigins) {
      setPickOriginForm((prev) => ({
        ...prev,
        fulfilmentOrigin: fulfilmentProviderOrigins[0].fulfilment_origin_id,
        useCustomsBroker:
          order.delivery_country !== fulfilmentProviderOrigins[0].country,
      }));
    }
  }, [fulfilmentProviderOrigins, order]);

  return {
    pickOriginForm,
    fulfilmentProviderOrigins,
    setPickOriginForm,
  };
};

export default useSetOriginForm;
